/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const openPositionConvertAdjustmentSchema = z.object({
  currentCommitment: z.number(),
  membershipId: z.int().nullish(),
  proposedCommitment: z.number(),
  teamId: z.int(),
  teamName: z.string().nullish(),
});
